export const MEDIA_QUERY_DESKTOP_SCREEN = '(min-device-width: 895px)';
export const MEDIA_QUERY_MEDIUM_SCREEN = '(max-device-width: 800px)';
export const MEDIA_QUERY_MEDIUM_SCREEN_700 = '(max-device-width: 700px)';
export const MEDIA_QUERY_MEDIUM_SCREEN_750 = '(max-device-width: 750px)';
export const MEDIA_QUERY_MEDIUM_SCREEN_850 = '(max-device-width: 850px)';
export const MEDIA_QUERY_LARGE_SCREEN = '(max-device-width: 900px)';
export const MEDIA_QUERY_LARGE_SCREEN_1200 = '(max-device-width: 1200px)';
export const MEDIA_QUERY_LARGE_SCREEN_1400 = '(max-device-width: 1400px)';
export const MEDIA_QUERY_LARGE_SCREEN_1080 = '(max-device-width: 1080px)';
export const MEDIA_QUERY_SMALL_SCREEN = '(max-device-width: 500px)';
export const MEDIA_QUERY_TALL_SCREEN = '(min-device-height: 750px)';
export const MEDIA_QUERY_IPHONE5_SCREEN = '(max-device-width: 325px)';

export const MEDIA_QUERY_SMALL_SCREEN_PROPS = {
  maxWidth: 500,
};
